
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as jwtRNg8ZusQpSkQ24J7yawNhuyYu0uta3VMuZFuxXArekwMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as riseidXy6KVb9tUgd8rvdWbsuy_45tvOjfgR8XB4aDi_Gpff_45bYMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as depositAhtSOFxnuH0bI_j7Z3UJpd3NeWWpekTRLNAiwOSYSF8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as deposit_45usOjdl3r2ohrkrF7AAPSGpAmHHSVUcidWf_4REnNPFsP0Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as _91accountId_93lwL2OIjUiIDtgn9JezrR7F5q4TE4qpZizZr__45VuCYwQMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as _91accountId_9309oZNufklIVmT6q5WbIdirr7iQjAOUupB6h5b8FcmlIMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as fundntA8EEXOIcaCnGZsfwzVcEX9n5_Ir2DTUcFAvkw0HjMMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexndtDkGk4aoimDYMPtye7VjenjAuQQL_45ee_HJBP1jHUEMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as riseidHLjuxKf3ugOxT64NqS8dc84WBHOMqMkj79_Q0OiHN_45sMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as accountrHqAnegZhOxgNbI_45I6nK1js3X01AyuzWDwJWiFWMOVIMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as blockedNFpa7x8koAT39cCekh6_AvQD3yjozwDaBPYu1Rgjsn8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as referralsK7JDijCTov4AILC03dCLMrZh_4522FYPxoLA_KjgEcV8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as securityAGL4kClTGyI2yuZFGTzk7AQw0il6ppigGxHsIpx2gvcMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45outUoyno2mQUkH5uqVQxUmCIgzq1wzuYpLufrkFe663YAkMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as _91accountId_930a5A_45LSAd_45Ni_k7Xtq95THCmqX5z5uvsYIrbb3SelW4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as _91accountId_93VVhssQX94529uYf0y3N3qDMbbILXr8We_45MbIoSyBJ_45EMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as withdrawrYFJZ_nAA_nNxQHg_45JaQ_sNpzomjwSGlyLLwQHlwDkcMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
import { default as dashboardz8JbNlcyQv1uDuSa_OnKJndclWNOIOYKY2nSRX3nTvcMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developereya1VikKZdUS9SoPQ5cFrk1rsyqQt_o5LZEI896i_45mQMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as login8QQMjOBKBnW5uRBU1JbAZGxxd82h_6r4OSS8mmqT5G4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as onboardingMEXJeKUwQT44_45NI9v8ZvoHI3k5IxeIP7ESN1ke35tGYMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as playground3ZxSFQk5dSPoXbIgVSPZ4ItAp0IH_45kRahA7AD7ps7XoMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as _2fasfLipzAZ9hD0GatuDg7LfXF1WhJtPxJWuKiOT4_45ZXDMMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as indexd7dfFeoR9aUBEkPd3SF8coxtVqRbHPkuycdIOiEVat8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as codeZCHckcGkNhz6x6cOUYH0fPhz_45vA3Xs2jB7frE8zIUdMMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as code9DhU5L1uGYjzDKB3qcaG5G9FDvu0htCGC8LrU3W3nS4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexkyo55VNTMEovdVmbvkfGsttho5zqA4dR9z6Y59Ah_45OcMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as registerbN_45SZbOLXUHlJseVoy_45XOREaq4wkp1kv2jeJ49azgFoMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as indexy5udt_45h2qD19z2z6o9Yj4hxO5a15WCThRc1EW0wB2h8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as _91code_93QE5NAJWp0Rz5_45ZejAlD2zbGWjXvBmPENVPuh_iHswQMMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as indexqC18nv6PuJPXBSiGbZozMSipge3d_45Ut7iYx_XzemIvsMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as sign_45documentRgxB0yDvUtFtyAth8QIPC0UVdd0rJodMHFC4A92jEcMMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as indexL4GiKa0f1_czSOWpRV8pOcpCsRIQGwB5azsMG32yTbgMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as indexaV7zepAFCGBfC8v2VUyECEPfxIgtXQESbzdChatSaUgMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as importlN_QaY79oeBIIJ_ux3rN9Hcwm_N2WVBcJ0uOKLXqsNUMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as directCU5oOt_9G_45nzBWAsVSN30uo3qPY5D5Dsl1P0RkXzGq4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsubTV_tD02DImOr0MrCVJspw1Z9b_45MwVe8PBDfaGi4iVloMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmeddTLnqMXiYdtzYu8H4__mnSxBHMi4VagEm_45j6NaF_VeUMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as batch_warmedpjz5_450oxKGkUoHXQGAm8WAHrRYzfugnEJkpDeywhVMUMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as warmed_lighttiYgjtxhMKaanxPHGbCMLhKaqIvqiUVgbWFiO7Jx3OAMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as batch_warmed_lightSUv72B1WhnO_45tV0o8wgDz0J6OYG15IRS10M4eAIRkuwMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as invitepkUBm0D8DlNZDw1wrZ9ilyP1oaFYE05TIYHCgwVWbBEMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as indexjXjm6C8YOsLwTQUjy1IPrZyjeF70LBHc6mANsYakGt8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as indexicDendRvDPlm8_45pseqIBztebvrYsqhXTWN4bxV1PKnQMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as waitingUvqFqqIsnSOp7En6ZH2twZ6PinADIr2HytNwJ_45xfEaIMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as business40PQf5ZOP1bNVV5qraVn64xWZXqxQDsM5Y7JiUEWtAoMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as callbackeK8Pn65h9ocWGMg0zQyRg6ob57fhNZ7bor_DNtVbEi8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as _91id_937wcG06X1_zVa98AEPGtMvNkbI4rfN_457PgqkTz2L4Yx0Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as index6srY9ebcK47eyg8RvaJFx21QT2Ue5Pyf8DLujFTRdc4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as _91uuid_93Zv5hnBJIu9lQQ2zJkgEnQGuHuVma54Komn7wZp7gnYoMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as index_c9laqVL54A_bLiNLd8m69uzZIEgEXGJHQaLqY3kw_IMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as indexuPXqN9OyOxzbma06sPbD9PWnz3w8V7maFFVEw7KQrwcMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as indexC3qzRVKB_L5i_u8GXJUsEQZV3pQdrWHNNpCouVap538Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as optionsvT__AokeM2PmGcS8hbwh5REXx6oYFFJ1jmY3l24Qjt0Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as riseid_45erc20_45withdraw83lOwS8QQ_I_45z_99PPk7l72dLGPn3jgMhTM9mbO_45udwMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as _91token_93A9Mh7Vhi7PNVmS36BshjNy3Z7BdGt8upl1mC_45iqIVE0Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as index9M1HBcqxcqVSrvn59dBTbEhDlXPp6G_45PTJZXMEo5hOQMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as indexigPdXlJK_45RYT2PpOyVLByQqqx43iQFml5j5NRqr5aXAMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as index7YomE4kZArgtLdFNGHD4YjCS3pcH7MzskcOIH_ZM9O4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as ramps44h5LYmiy6RBHSki8BaziQoba2x1NvPTvG7Aua40Kg8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as classificationoF5FgOK9gUmgl2H0Ffgb_Jc7YorDgopbGTPXvb450s4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as _91id_937apSrFw95o9uYV9_I7G7_5NPALwP8Lgo7tr1J3rhzVgMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as blockchain_45wallet91DRAVK_45tHAI28nxX06ZUvUMiupmbFAJClABFQ9IhWYMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45address7C6HM487xUKC_453LAqdCbteGSp4l_nqzPD77u_wtMFeUMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as options76ppFG3r0KmejXQ_w4sWgJNbJptVij34U1XTnRqOjQsMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as transaction_45history8qxtXReNOxL0dj6xyW7lT_45AI7dFArChMcldfrBqX5MMMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as usFm26d2XJYiAVzEuZK2Tk2DcucmKRVAAFs8YP0fmqGlwMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as eurHazIpw5kS3nLVP6LQp_ymiwvZ8TLGdRH48r8rHToT_gMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as gbpNer5GYfj1d3I63R8cPZUzVqChMV5IEG5QFV_0Q052oUMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as ngnkB18RCO5xoZE7fmJGpr9LNIQvHQQqqWQV2xb2XpyPaoMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as brlarumUBBGBEqf9dr2hkAIWyeJRrzuyqwxyocBh4OiG4H0Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as forexvyeV7ZwxTLBD3z7DRE4n_45EOuYQaN3PLbCcDPBwURsesMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as krakenDZeXWWH6sNAUOjH_45TtvQJWk3l8IaNtxtvkVPUzWp0WkMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as binanceJZKuZ9pGN6I0roNMHiZq8z1yAQlSVBYS7c3MMlk7SrgMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as coinbaseKtEqIKQSBhniDnVZTx_45PeOGPt4U0BX7ul_qlZiC5XS4Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as internationalZ09stNEvQs4rdq6qMYMnI7UlCCivqrQffk_5UAOX4WIMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as coinbase_walletbsUKdsQkh_45dCAGlCnx41u_45DjQgMtxa9Nr45U1bWFExAMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as international_bankLMj3i_45CeysyM5CYEeCTx0k_ulZbkkvNOJr5WXQaIz8wMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as indexuzAyjychxoGyecKG3wSHUCKCAQ2jgS6LDj1ok4BU1TEMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as _91network_930JIAeBERScYa7iyZdlH_45I3tCNgXFCZ37I8FuYQbMNVMMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as options3azgT_459xMzcwwXiHGx_45yIRL_b7CFq7_45mXxuYztLg_45JIMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as coinbasePZRMtl07hNpWlqmGbHhQGVWOs6T6DBebqiCdh5Sy22oMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as teamKy_Ne1zP_45ohrcLOJn2NRfmV8Fi8x2Txho_Nzdz3JiVIMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as _91id_93e117Nv8MQ31pJinJSdoUvrWQb8duyP9RDx9eD44IisUMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as indexVeF7gjiUTwZbzTfx0hPtiIXOA_eG9Jav_ic_45rEYKJ0IMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as verify_45walletOhbwbcYYrj8ZRAU5iLEil7edo_45BgovipYAlEdE3IrP8Meta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as pay_schedule4hblyLFRItCXamMXeO4g7W3KVExYOxpmdr_GmJD5qOgMeta } from "/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
export default [
  {
    name: "jwt",
    path: "/jwt",
    meta: jwtRNg8ZusQpSkQ24J7yawNhuyYu0uta3VMuZFuxXArekwMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fundntA8EEXOIcaCnGZsfwzVcEX9n5_Ir2DTUcFAvkw0HjMMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseidXy6KVb9tUgd8rvdWbsuy_45tvOjfgR8XB4aDi_Gpff_45bYMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: depositAhtSOFxnuH0bI_j7Z3UJpd3NeWWpekTRLNAiwOSYSF8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45usOjdl3r2ohrkrF7AAPSGpAmHHSVUcidWf_4REnNPFsP0Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93lwL2OIjUiIDtgn9JezrR7F5q4TE4qpZizZr__45VuCYwQMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_9309oZNufklIVmT6q5WbIdirr7iQjAOUupB6h5b8FcmlIMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexndtDkGk4aoimDYMPtye7VjenjAuQQL_45ee_HJBP1jHUEMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseidHLjuxKf3ugOxT64NqS8dc84WBHOMqMkj79_Q0OiHN_45sMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountrHqAnegZhOxgNbI_45I6nK1js3X01AyuzWDwJWiFWMOVIMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blockedNFpa7x8koAT39cCekh6_AvQD3yjozwDaBPYu1Rgjsn8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referralsK7JDijCTov4AILC03dCLMrZh_4522FYPxoLA_KjgEcV8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: securityAGL4kClTGyI2yuZFGTzk7AQw0il6ppigGxHsIpx2gvcMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outUoyno2mQUkH5uqVQxUmCIgzq1wzuYpLufrkFe663YAkMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdrawrYFJZ_nAA_nNxQHg_45JaQ_sNpzomjwSGlyLLwQHlwDkcMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  },
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardz8JbNlcyQv1uDuSa_OnKJndclWNOIOYKY2nSRX3nTvcMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developereya1VikKZdUS9SoPQ5cFrk1rsyqQt_o5LZEI896i_45mQMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingMEXJeKUwQT44_45NI9v8ZvoHI3k5IxeIP7ESN1ke35tGYMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: indexd7dfFeoR9aUBEkPd3SF8coxtVqRbHPkuycdIOiEVat8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: indexkyo55VNTMEovdVmbvkfGsttho5zqA4dR9z6Y59Ah_45OcMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: indexy5udt_45h2qD19z2z6o9Yj4hxO5a15WCThRc1EW0wB2h8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexqC18nv6PuJPXBSiGbZozMSipge3d_45Ut7iYx_XzemIvsMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45documentRgxB0yDvUtFtyAth8QIPC0UVdd0rJodMHFC4A92jEcMMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexL4GiKa0f1_czSOWpRV8pOcpCsRIQGwB5azsMG32yTbgMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: importlN_QaY79oeBIIJ_ux3rN9Hcwm_N2WVBcJ0uOKLXqsNUMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: invitepkUBm0D8DlNZDw1wrZ9ilyP1oaFYE05TIYHCgwVWbBEMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexjXjm6C8YOsLwTQUjy1IPrZyjeF70LBHc6mANsYakGt8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexicDendRvDPlm8_45pseqIBztebvrYsqhXTWN4bxV1PKnQMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waitingUvqFqqIsnSOp7En6ZH2twZ6PinADIr2HytNwJ_45xfEaIMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: business40PQf5ZOP1bNVV5qraVn64xWZXqxQDsM5Y7JiUEWtAoMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_937wcG06X1_zVa98AEPGtMvNkbI4rfN_457PgqkTz2L4Yx0Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: index6srY9ebcK47eyg8RvaJFx21QT2Ue5Pyf8DLujFTRdc4Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93Zv5hnBJIu9lQQ2zJkgEnQGuHuVma54Komn7wZp7gnYoMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: index_c9laqVL54A_bLiNLd8m69uzZIEgEXGJHQaLqY3kw_IMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: indexuPXqN9OyOxzbma06sPbD9PWnz3w8V7maFFVEw7KQrwcMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexC3qzRVKB_L5i_u8GXJUsEQZV3pQdrWHNNpCouVap538Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: optionsvT__AokeM2PmGcS8hbwh5REXx6oYFFJ1jmY3l24Qjt0Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdraw83lOwS8QQ_I_45z_99PPk7l72dLGPn3jgMhTM9mbO_45udwMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_93A9Mh7Vhi7PNVmS36BshjNy3Z7BdGt8upl1mC_45iqIVE0Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: index9M1HBcqxcqVSrvn59dBTbEhDlXPp6G_45PTJZXMEo5hOQMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: indexigPdXlJK_45RYT2PpOyVLByQqqx43iQFml5j5NRqr5aXAMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: index7YomE4kZArgtLdFNGHD4YjCS3pcH7MzskcOIH_ZM9O4Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: ramps44h5LYmiy6RBHSki8BaziQoba2x1NvPTvG7Aua40Kg8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classificationoF5FgOK9gUmgl2H0Ffgb_Jc7YorDgopbGTPXvb450s4Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_937apSrFw95o9uYV9_I7G7_5NPALwP8Lgo7tr1J3rhzVgMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: options76ppFG3r0KmejXQ_w4sWgJNbJptVij34U1XTnRqOjQsMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45history8qxtXReNOxL0dj6xyW7lT_45AI7dFArChMcldfrBqX5MMMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: options3azgT_459xMzcwwXiHGx_45yIRL_b7CFq7_45mXxuYztLg_45JIMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  }
]
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamKy_Ne1zP_45ohrcLOJn2NRfmV8Fi8x2Txho_Nzdz3JiVIMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_93e117Nv8MQ31pJinJSdoUvrWQb8duyP9RDx9eD44IisUMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexVeF7gjiUTwZbzTfx0hPtiIXOA_eG9Jav_ic_45rEYKJ0IMeta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletOhbwbcYYrj8ZRAU5iLEil7edo_45BgovipYAlEdE3IrP8Meta || {},
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/gh24/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  }
]